<template>
  <div class="block">
    <div class="container">
      <div class="title title-cust">{{ title }}</div>
      <div class="entitle entitle-cust">
        {{ entitle }}
      </div>

      <div class="row wrap-img">
        <div class="col-percent-20" v-for="(item, index) in imgs" :key="index">
          <div class="box-img">
            <img
              :src="item"
              class="img-responsive img-cust hvr-bounce-in"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import p1 from "@/assets/images/customer/p1.png";
import p2 from "@/assets/images/customer/p2.png";
import p3 from "@/assets/images/customer/p3.png";
import p4 from "@/assets/images/customer/p4.png";
import p5 from "@/assets/images/customer/p5.png";
import p6 from "@/assets/images/customer/p6.png";
import p7 from "@/assets/images/customer/p7.png";
import p8 from "@/assets/images/customer/p8.png";
import p9 from "@/assets/images/customer/p9.png";
import p10 from "@/assets/images/customer/p10.png";
import p11 from "@/assets/images/customer/p11.png";
import p12 from "@/assets/images/customer/p12.png";
import p13 from "@/assets/images/customer/p13.png";
import p14 from "@/assets/images/customer/p14.png";
import p15 from "@/assets/images/customer/p15.png";
import p16 from "@/assets/images/customer/p16.png";
import p17 from "@/assets/images/customer/p17.png";
import p18 from "@/assets/images/customer/p18.png";
import p19 from "@/assets/images/customer/p19.png";
import p20 from "@/assets/images/customer/p20.png";

let imgs = [
  p1,
  p2,
  p3,
  p4,
  p5,
  p6,
  p7,
  p8,
  p9,
  p10,
  p11,
  p12,
  p13,
  p14,
  p15,
  p16,
  p17,
  p18,
  p19,
  p20,
];
export default {
  props: ["title", "entitle"],
  data() {
    return {
      imgs,
    };
  },
};
</script>

<style scoped>
.title-cust {
  color: #2f56ce;
}
.entitle-cust {
  color: #b3b3b3;
}
.wrap-img {
  margin-top: 60px;
}
.box-img {
  height: 100px;
}
/* 扩展栅格 */
.col-percent-20 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
  float: left;
  width: 20%;
}
/*  */
.mb .col-percent-20 {
  width: 33.3333%;
}
</style>